import { PaywallResourceMapper } from "./resource.map";
import { Trello } from "types/my-trello-types";
import type { Resource } from "@trello-powerup-monorepo/iframe-messenger-paywall-v2/parent";

const EMPTY_RESOURCES: Resource[] = [];

export class PaywallResourceQueries {
  static resourceQuery(context?: Trello.PowerUp.Context) {
    if (!context) {
      return EMPTY_RESOURCES;
    }
    return PaywallResourceMapper.toPaywallResources(context);
  }
}
